import { render, staticRenderFns } from "./user-info-view.vue?vue&type=template&id=18ac5ae1&scoped=true&"
import script from "./user-info-view.vue?vue&type=script&lang=ts&"
export * from "./user-info-view.vue?vue&type=script&lang=ts&"
import style0 from "./user-info-view.vue?vue&type=style&index=0&id=18ac5ae1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ac5ae1",
  null
  
)

export default component.exports